import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, ArrowRight } from 'lucide-react';
import Bottle from '@/components/ui/Bottle';

export default function ProductCard({ product, variant = 'default' }) {
  return (
    <div
      data-testid={`product-card-${product.id}`}
      className="group glass-card rounded-3xl p-6 lg:p-7 flex flex-col gap-5 hover:border-gold/30 hover:-translate-y-1 transition-all duration-500"
    >
      {/* visual */}
      <div className="relative bottle-stage h-72 flex items-end justify-center pt-8 pb-3">
        <div className="absolute top-3 left-3 flex items-center gap-2">
          {product.bestseller && (
            <span className="text-[10px] tracking-[0.22em] uppercase px-3 py-1 rounded-full bg-gold/20 text-gold border border-gold/30">
              Bestseller
            </span>
          )}
        </div>
        <Bottle product={product} size="md" floating />
        <div
          className="absolute inset-x-0 bottom-0 h-20 opacity-60 pointer-events-none"
          style={{ background: `radial-gradient(ellipse at center bottom, ${product.accent}33, transparent 70%)` }}
        />
      </div>

      {/* meta */}
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-[10px] tracking-[0.28em] uppercase text-bone-300/80">{product.volume}</p>
          <h3 className="font-display text-2xl text-bone-50 mt-1.5">{product.name}</h3>
          <p className="text-sm text-bone-200/85 mt-1 leading-relaxed line-clamp-2">{product.tagline}</p>
        </div>
        <span className="font-display text-2xl text-gold whitespace-nowrap">₹{product.price}</span>
      </div>

      {/* actions */}
      <div className="flex items-center gap-3 mt-1">
        <button className="btn-primary flex-1 !py-3" data-testid={`add-to-cart-${product.id}`}>
          <ShoppingBag className="w-4 h-4" /> Add To Cart
        </button>
        <Link
          to={`/shop/${product.id}`}
          className="btn-ghost-icon"
          data-testid={`view-${product.id}`}
          aria-label="View details"
        >
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
